module.exports = __webpack_public_path__ + "assets/img/group-mapping.eac4e823.svg";